import i18n from "./localization";

// @ts-ignore  TODO: remove ? it's not needed here
export function t(string: string, options?: any = {}): string {
  // @ts-expect-error
  return i18n.t(string, options);
}
